import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'
import { IReporteesApiResponse } from '@app/core/models/reportees.model'
import { API_ERRORS } from '@app/core/constants/api-errors.constants'

@Injectable({ providedIn: 'root' })
export class ReporteesService {
    private readonly http = inject(HttpClient)
    private readonly apiBaseUrl = environment.apiBaseUrl

    getReportees(userId: string): Observable<IReporteesApiResponse> {
        const url = `${this.apiBaseUrl}/api/aggregated/v1/users/${encodeURIComponent(userId)}/reportees`
        return this.http.get<IReporteesApiResponse>(url, { withCredentials: true }).pipe(
            map((response) => {
                const hasReportees = !!response.data?.reportees?.length
                if (!hasReportees) {
                    return {
                        success: false,
                        message: API_ERRORS.NO_REPORTING_USERS_FOUND,
                    }
                }
                return {
                    success: response.success ?? false,
                    message: response.message ?? '',
                    data: response.data,
                }
            }),
            catchError(() =>
                of({
                    success: false,
                    message: API_ERRORS.NO_REPORTING_USERS_FOUND,
                }),
            ),
        )
    }

    hasReportees(userId: string): Observable<boolean> {
        return this.getReportees(userId).pipe(
            map((response) => response.success && !!response.data?.reportees?.length),
        )
    }
}
